import { Settings } from "@mui/icons-material";
import { Box, Container } from "@mui/material";
import GlobalNavigation from "../../components/GlobalNavigation";
import Header from "../../components/Header";
import Helmet from "../../components/Helmet";
import Layout, {
  LayoutStateProvider,
  SidebarSwitch,
  SideSheetTrigger,
} from "../../components/Layout";
import Loading from "../../components/Loading";
import NoDataStoreAlert from "../../components/NoDataStoreAlert";
import SettingsDrawer from "../../components/SettingsDrawer";
import { useRecord } from "../../domain/crud";
import { useRecordParams } from "../../paths";
import { selectData } from "../../utils";
import { RecordEditForm } from "./components/RecordEditForm";

export function EditRecord() {
  const { topicId, timestamp } = useRecordParams();

  const recordQuery = useRecord(topicId, timestamp, { select: selectData });

  return (
    <>
      <Helmet>
        <title>Edit Record</title>
      </Helmet>
      <LayoutStateProvider>
        <Layout
          header={
            <Header
              title="Edit Record"
              actions={
                <SideSheetTrigger
                  title="Settings"
                  sidebarId="settings"
                  icon={<Settings />}
                />
              }
            />
          }
          globalNavigation={<GlobalNavigation />}
          sideSheet={
            <SidebarSwitch
              config={[
                {
                  id: "settings",
                  element: <SettingsDrawer />,
                },
              ]}
            />
          }
        >
          <Box sx={{ flexGrow: 1, minWidth: 0, overflowY: "auto", py: 4 }}>
            <Container fixed>
              <NoDataStoreAlert sx={{ mb: 4 }} />
              {recordQuery.isSuccess ? (
                <RecordEditForm record={recordQuery.data} />
              ) : (
                <Loading type="circular" />
              )}
            </Container>
          </Box>
        </Layout>
      </LayoutStateProvider>
    </>
  );
}
